import React from 'react';
import { Box, TextField, Alert, Typography } from '@mui/material';

import { MethodEditorProps } from '../types';

export const NavigateEditor: React.FC<MethodEditorProps> = ({ payload, onChange }) => (
  <Box>
    <TextField
      fullWidth
      value={payload?.url || ''}
      onChange={(e) => onChange({ ...payload, url: e.target.value })}
      label="URL"
      placeholder="/campaigns/new?type=campaign#description"
      helperText="Supports query parameters and hash fragments for section scrolling"
      margin="normal"
    />
    <Alert severity="info" sx={{ mt: 2 }}>
      <Typography variant="body2">
        <strong>Examples:</strong>
        <br />• /campaigns/new
        <br />• /campaigns/new?type=campaign
        <br />• /campaigns/new#description (scrolls to section)
      </Typography>
    </Alert>
  </Box>
);
